module.exports = {
    'tables.task.country': '国家',
    'tables.task.taskNumber': '任务编号',
    'tables.task.platform': '所属平台',
    'tables.task.shopName': '所属店铺',
    'tables.task.perItem': '每单品类',
    'tables.task.releaseTime': '发布时间',
    'tables.task.courierNumber': '快递单号',
    'tables.task.creationTime': '创建时间',
    'tables.task.endTime': '任务完成时间',
    'tables.task.totalTask': '任务总额',
    'tables.task.totalGoods': '商品金额',
    'tables.task.taskStatus': '任务状态',
    'tables.task.failReason': '失败原因',
    'tables.task.failPic': '失败图片',
    'tables.task.orderStatus': '订单状态',
    'tables.task.operate': '操作',
    'tables.task.orderNumber': '订单号',
    'tables.task.payByHand': '刷手实付',
    'tables.task.brush': '刷手',
    'tables.task.courierName':'快递员姓名',
    'tables.task.courierPhone':'快递员电话',
    'tables.task.courierCompany':'快递员公司',

    'tables.task.theActualAmount': '实际金额',
    'tables.task.evaluationAccount': '测评账号',
    'tables.task.taskTimeliness': '任务处理时效',

    // 投诉
    'tables.complaint.type': '投诉类型',
    'tables.complaint.content': '投诉内容',
    'tables.complaint.screenshot': '内容截图',
    'tables.complaint.time': '投诉时间',
    'tables.complaint.sum': '总金额',
    'tables.complaint.brushGoodsAmount': '刷手商品金额',
    'tables.complaint.brushServiceAmount': '刷手佣金金额',
    'tables.complaint.result': '投诉结果',
    'tables.complaint.remark': '备注',
    'tables.complaint.status': '投诉状态',
    'tables.complaint.brush': '刷手',

    // acct
    'tables.acct.completeTime': '完成时间',
    'tables.acct.settlementType': '结算类型',
    'tables.acct.settlementServicePrice': '结算佣金金额',
    'tables.acct.commission':'刷手佣金金额',
    
    'tables.acct.settlementGoodsPrice': '结算商品金额',

    'tables.acct.settlementStatus': '结算状态',
    'tables.acct.serviceAdminName': '刷手负责人',
    'tables.acct.settlementAdminName': '结算操作人',
    'tables.acct.settlementVoucher': '结算凭证',
    'tables.acct.settlementTime': '结算时间',
    'tables.acct.business': '商家',
    'tables.acct.prepaidVoucher': '预付凭证',
    'tables.acct.batchReceive': '批量领取',

    // brush
    'tables.brush.number': '刷手编号',
    'tables.brush.name': '刷手姓名',
    'tables.brush.mobile': '刷手手机号',
    'tables.brush.account': '账号',
    'tables.brush.state': '状态',
    'tables.brush.commission':'佣金',
    'tables.brush.authorizeAllOrder':'授权全部订单收货',

    'navBar.lang': '语言',
    'layout.user.link.help': '帮助',
    'layout.user.link.privacy': '隐私',
    'layout.user.link.terms': '条款',
    'app.copyright.produced': '蚂蚁集团体验技术部出品',
    'app.preview.down.block': '下载此页面到本地项目',
    'app.welcome.link.fetch-blocks': '获取全部区块',
    'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
    'alert.user.pwd': '提示：初始密码为123456',
    'alert.Tip': '提示',
    'app:edit': '编辑',
    'app:delete': '删除',
    'app:disable': '禁用',
    'app:enable': '启用',
    'app:resetPwd': '重置密码',
    'toast:success': '操作成功!',
    'app:download': '下载',
    'app:downloadsphpmb':'下载商品好评模板',
    'app:batchImportshhp':'批量导入商品好评',
    'app:downloadxd':'下载批量下单模板',
    'app:batchImportxd':'批量导入下单任务',

    'app:detail': '详情',
    'app:printDelivery': '打印送货单',
    'app:updatePaidinamount':'修改实付金额',
    'app:please':'请输入',
    'app:Complaintcontent':'实付金额',
    'app:update':'修改',

    'app:complaint': '投诉',
    'app:placeOrder': '下单',
    'app:comment': '商品好评',
    'app:signSuccess':'签收成功',
    'app:signFailed': '签收失败',
    'app:signStatus': '签收情况',
    'app:sign':'签收',
    'app:ScanCodeSign':'扫描收货',
    'app:receive': '领取任务',
    'app:assignment': '分配',

    'user:title': '用户中心',
    'user:changePassword': '更换密码',
    'user:logout': '退出登录',
    'user:logoutMsg': '确定退出登录吗？',
    'user:companyName': '公司名称',
    'user:expirationTime': '到期时间',
    'user:realName': '当前用户',
    'user:changeSuccessMsg': '操作成功，请重新登录',
    'user:oldPassword': '旧密码',
    'user:newPassword': '新密码',
    'user:closeOther': '关闭其他',
    'user:closeAll': '关闭所有',

    'login:account': '手机号',
    'login:pwd': '密码',
    'login:login': '登录',
    'login:success': '登录成功！',

    'app:count': '数量',
    'conditionExpansion': '展开',
    'conditionCollapse': '收起',
    'messagedetermine':'确定',
    'messagecancel':'取消',

    'tableSearchQuery':'查询',
    'tableSearchReset':'重置',

    'pages.pf.leader.service-list.addBrush': '新建刷手',
    'pages.pf.leader.service-list.updateBrush': '编辑刷手',
    'pages.pf.leader.service-list.deleteMsg': '确定删除该人员吗',
    'pages.pf.leader.service-list.resetPassword': '确定重置该人员密码吗？初始密码为123456',
    'pages.pf.leader.service-list.disable': '确定禁用该人员账号吗？',
    'pages.pf.leader.service-list.enable': '确定启用该人员账号吗？',

    'pages.bs.task.return': '退回',
    'pages.bs.task.returnMsg': '确认退回该任务至需求池吗？',
    'pages.ld.task.receive': '确认领取该任务吗？',
    'pages.ld.task.receiveMsg': '领取该任务后，您需要在240分钟完成下单，若未完成将会自动退回到任务池',

    // 下单
    'pages.placeOrder.title': '下单',
    'pages.placeOrder.additionalServices': '附加服务',
    'pages.placeOrder.otherServiceScreenMsg': '请上传任务截图',
    'pages.upload.extra': '支持.jpg、.png 格式',
    'pages.upload.title': '上传图片',
    'pages.placeOrder.transactionScreenshot': '交易截图',
    'pages.placeOrder.screenshot': '截图',
    'pages.placeOrder.failureReason': '失败原因',
    'pages.placeOrder.TaskAmount': '任务金额',
    'pages.placeOrder.PayAmount': '刷手实付金额',
    'pages.placeOrder.submit': '提交',
    'pages.placeOrder.OrderPlacement': '下单情况',
    'pages.placeOrder.OrderSuccess': '下单成功',
    'pages.placeOrder.Orderfailed': '下单失败',
    'pages.comment.screenshot': '评论截图',

    'pages.detail.title': '任务单信息',
    'pages.detail.baseInfo': '基础信息',

    'pages.detail.cost': '费用',
    'pages.detail.taskCost': '任务合计',
    'pages.detail.goodsCost': '商品总计',
    'pages.detail.otherPrice': '附加服务费',
    'pages.detail.isFreeShipping': '是否包邮',
    'pages.detail.goodsLink': '商品链接',

    'pages.detail.goodsName': '关键词',
    'pages.detail.coupon': '优惠券',
    'pages.detail.goodsCover': '商品主图',
    'pages.detail.skuCount': 'sku数量',
    'pages.detail.unitPrice': '下单单价',


    'pages.detail.commentStar': '评论星级',
    'pages.detail.PraiseContent': '好评内容',
    'pages.detail.ScreenshotOfPraise': '好评晒图',
    'pages.detail.VideoPraise': 'shopee视频好评',

    'pages.detail.inStoreType': '进店方式',
    'pages.detail.SearchKeywords': '搜索关键词',
    'pages.detail.OtherChannels': '其他渠道',
    'pages.detail.StoreAddress': '进店地址',

    'pages.detail.SortingMethod': '排序方式',
    'pages.detail.desc': '描述',

    'pages.detail.required': '要求',

    'pages.detail.notRequired': '不要求',
    'pages.detail.item1': '货比一家',
    'pages.detail.item2': '货比两家',
    'pages.detail.item3': '货比三家',

    'pages.detail.TaskSituation': '任务完成情况',



    'pages.detail.otherServiceScreen': '附加服务截图',

    'menu.first.task': '测评管理',
    'menu.first.task.pool': '任务池',
    'menu.first.task.Received': '已接任务',
    'menu.first.task.Scan': '扫描收货',
    'menu.first.task.detail': '任务详情',
    'menu.first.task.complaint': '投诉列表',
    'menu.first.task.comment': '商品好评',
    'menu.first.task.placeOrder': '下单',
  
    'menu.first.acct': '资金管理',
    'menu.first.task.bill': '佣金账单',
  
    'menu.first.service': '刷手管理',
    'menu.first.task.list': '刷手列表',
}  


// WEBPACK FOOTER //
// ./src/components/lang/zh.js